<template>
  <div>
  <router-link to="/plan/tools" class="back-link">
    <Flexy><img :src="ArrowRightIcon" /> <p>{{t('Blood Test')}}</p></Flexy>
  </router-link>
  <div class="panel">
  <p>{{t('blood-test-intro')}}</p>
  </div>
  <div class="panel" v-if="hasResults">
    <h3>{{t('Blood Test Results')}}</h3>
    <p>{{t('blood-test-results-intro')}}</p>
    <div class="blood-test-results">
        <Flexy>
          <b>{{t('National ID')}}</b>
          <p>{{submittedNationalId}}</p>
        </Flexy>
        <Flexy>
          <b>{{t('Test Date')}}</b>
          <p>{{submittedTestDate}}</p>
        </Flexy>
        <Flexy v-for="(value, key) in submittedTestResults" :key="key">
          <b>{{t(key)}}</b>
          <p>{{value}}</p>
        </Flexy>

    </div>
  </div>
  <div class="panel" v-else>
    <InputWrapper :mandatory-sign="true" :label="t('National ID')" type="text" v-model="natlId" :placeholder="t('National ID')" />
    <InputWrapper :mandatory-sign="true" :label="t('Test Date')" type="date" v-model="testDate" :placeholder="t('Test Date')" />
    <InputWrapper :label="t('Hemoglobin')" type="number" v-model="hemoglobin" :placeholder="t('Hemoglobin')" />
    <InputWrapper :label="t('Glucose')" type="number" v-model="glucose" :placeholder="t('Glucose')" />
    <InputWrapper :label="t('Hemoglobin A1C')" :comment="t('hemoglobin-a1c-comment')" type="number" v-model="hemoglobin_a1c" :placeholder="t('Hemoglobin A1C')" />
    <InputWrapper :label="t('Cholesterol Total')" type="number" v-model="cholesterol_total" :placeholder="t('Cholesterol Total')" />
    <InputWrapper :label="t('Cholesterol LDL')" type="number" v-model="cholesterol_ldl" :placeholder="t('Cholesterol LDL')" />
    <InputWrapper :label="t('Cholesterol HDL')" type="number" v-model="cholesterol_hdl" :placeholder="t('Cholesterol HDL')" />
    <InputWrapper :label="t('Cholesterol VLDL')" type="number" v-model="cholesterol_vldl" :placeholder="t('Cholesterol VLDL')" />
    <InputWrapper :label="t('Cholesterol Non HDL')" type="number" v-model="cholesterol_non_hdl" :placeholder="t('Cholesterol Non HDL')" />
    <InputWrapper :label="t('Triglycerides')" type="number" v-model="triglycerides" :placeholder="t('Triglycerides')" />
    <InputWrapper :label="t('Iron Fe')" type="number" v-model="iron_fe" :placeholder="t('Iron Fe')" />
    <InputWrapper :label="t('Ferritin')" type="number" v-model="ferritin" :placeholder="t('Ferritin')" />
    <InputWrapper :label="t('TSH')" type="number" v-model="tsh" :placeholder="t('TSH')" />
    <InputWrapper :label="t('Vitamin B12')" type="number" v-model="vitamin_b12" :placeholder="t('Vitamin B12')" />
    <InputWrapper :label="t('Folic Acid')" type="number" v-model="folic_acid" :placeholder="t('Folic Acid')" />
    <InputWrapper :label="t('CRP')" type="number" v-model="crp" :placeholder="t('CRP')" />
    <InputWrapper :label="t('ALT')" type="number" v-model="alt" :placeholder="t('ALT')" />
    <InputWrapper :label="t('AST')" type="number" v-model="ast" :placeholder="t('AST')" />
    <InputWrapper :label="t('Vitamin D')" type="number" v-model="vitamin_d" :placeholder="t('Vitamin D')" />

    <p class="centered danger" v-if="fillWarning">{{t("Please fill in all the mandatory fields")}}</p>
  </div>
  <div class="panel">
    <div class="buttons">
      <button v-if="hasResults" class="btn" @click="editResults">{{t('Edit Results')}}</button>
      <button v-else class="btn btn-primary" @click="onSubmit">{{t('Submit Blood Test')}}</button>
    </div>
  </div>
  </div>
</template>
<script>
import Flexy from "@/components/ui/widgets/Flexy.vue";
import ArrowRightIcon from '@/assets/icons/arrow-right.svg';
import t from '@/lib/Locale';
import InputWrapper from "@/components/ui/widgets/InputWrapper.vue";
import Fito from "@/lib/fito";

export default {
  name: "BloodTest",
  components: { Flexy, InputWrapper },
  data() {
    return {
      ArrowRightIcon,
      fillWarning: false,
      hasResults : false,

      natlId: '',
      testDate: '',
      hemoglobin: '',
      glucose: '',
      hemoglobin_a1c: '',
      cholesterol_total: '',
      cholesterol_ldl: '',
      cholesterol_hdl: '',
      cholesterol_vldl: '',
      cholesterol_non_hdl: '',
      triglycerides: '',
      iron_fe: '',
      ferritin: '',
      tsh: '',
      vitamin_b12: '',
      folic_acid: '',
      crp: '',
      alt: '',
      ast: '',
      vitamin_d: '',

      submittedNationalId: '',
      submittedTestDate: '',
      submittedTestResults: {},
    }
  },
  mounted() {
    console.log("BLOOD TEST")
    this.getBloodTestResults()
  },
  methods: {
    t,
    async getBloodTestResults() {
      const login = await Fito().Login.CheckLogin(true)
      if (!login) return this.$router.push('/plan/login')
      if (login['meta'] && login['meta']['blood-test-results']) {
        this.hasResults = true
        this.submittedNationalId = login['meta']['blood-test-results']['national_id']
        this.submittedTestDate = login['meta']['blood-test-results']['test_date']
        this.submittedTestResults = login['meta']['blood-test-results']['data']

        // convert this.submittedTestDate to dd/mm/yyyy
        const date = new Date(this.submittedTestDate)
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        this.submittedTestDate = `${day}/${month}/${year}`
      }
    },
    validate() {
      if (!this.natlId || !this.testDate) {
        this.fillWarning = true
        return false
      }
      return true
    },
    onSubmit() {
      if (!this.validate()) return
      const data = {
        hemoglobin: this.hemoglobin,
        glucose: this.glucose,
        hemoglobin_a1c: this.hemoglobin_a1c,
        cholesterol_total: this.cholesterol_total,
        cholesterol_ldl: this.cholesterol_ldl,
        cholesterol_hdl: this.cholesterol_hdl,
        cholesterol_vldl: this.cholesterol_vldl,
        cholesterol_non_hdl: this.cholesterol_non_hdl,
        triglycerides: this.triglycerides,
        iron_fe: this.iron_fe,
        ferritin: this.ferritin,
        tsh: this.tsh,
        vitamin_b12: this.vitamin_b12,
        folic_acid: this.folic_acid,
        crp: this.crp,
        alt: this.alt,
        ast: this.ast,
        vitamin_d: this.vitamin_d,
      }
      this.submitBloodTest(this.natlId, this.testDate, data)
        .then(() => {
          console.log('Blood test submitted')
          this.$router.push('/plan/tools?submitted_blood_test')
        })
        .catch(e => {
          console.error('Error submitting blood test',e)
          console.error(e)
        })

    },

    editResults() {
      this.hasResults = false
      // populate fields with data
      this.natlId = this.submittedNationalId
      // this.testDate = this.submittedTestDate
      // make sure to reformat the date to yyyy-mm-dd
      const dateParts = this.submittedTestDate.split('/')
      this.testDate = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`
      console.log(this.testDate)
      for (let key in this.submittedTestResults) {
        this[key] = this.submittedTestResults[key]
      }
    },

    async submitBloodTest(national_id, test_date, data) {
      // run the action 'submit-blood-test' with given props
      const res = await Fito().RunAction('submit-blood-test', {national_id, test_date, data})
      console.log(res)

      return res
    }
  }
}

</script>